import * as XLSX from "xlsx";

const safe = (value) =>
  value === null || value === undefined ? "" : String(value);

/**
 * Toplantı tutanağını .xlsx olarak indirir.
 * @param {object} params
 * @param {string} [params.fileName]
 * @param {string} [params.subject]
 * @param {string|Date} [params.dateTime]
 * @param {string[]} [params.topics]
 * @param {{todo?:string,owner?:string,endDate?:string}[]} [params.todos]
 * @param {string[]} [params.desicions]
 * @param {{side?:string,position?:string,displayName?:string,email?:string,phoneNumber?:string}[]} [params.participants]
 */
export function exportOfficialReportExcel({
  fileName = "toplanti-tutanagi",
  subject = "",
  dateTime = "",
  topics = [],
  todos = [],
  desicions = [],
  participants = [],
} = {}) {
  const wb = XLSX.utils.book_new();

  const overview = [
    ["Toplantı Tutanağı"],
    [],
    ["Tarih Saat", safe(dateTime)],
    ["Konu", safe(subject)],
  ];
  const wsOverview = XLSX.utils.aoa_to_sheet(overview);
  wsOverview["!cols"] = [{ wch: 18 }, { wch: 50 }];
  XLSX.utils.book_append_sheet(wb, wsOverview, "Özet");

  const topicRows = [["#", "Başlık"]];
  (topics || []).forEach((topic, i) => {
    topicRows.push([i + 1, safe(topic)]);
  });
  if (topicRows.length === 1) topicRows.push(["", ""]);
  const wsTopics = XLSX.utils.aoa_to_sheet(topicRows);
  wsTopics["!cols"] = [{ wch: 6 }, { wch: 70 }];
  XLSX.utils.book_append_sheet(wb, wsTopics, "Başlıklar");

  const todoRows = [["#", "Açıklama", "Sorumlu Taraf/Kişi", "Bitiş Tarihi"]];
  (todos || []).forEach((todo, i) => {
    todoRows.push([
      i + 1,
      safe(todo?.todo),
      safe(todo?.owner),
      safe(todo?.endDate),
    ]);
  });
  if (todoRows.length === 1) todoRows.push(["", "", "", ""]);
  const wsTodos = XLSX.utils.aoa_to_sheet(todoRows);
  wsTodos["!cols"] = [{ wch: 6 }, { wch: 45 }, { wch: 24 }, { wch: 16 }];
  XLSX.utils.book_append_sheet(wb, wsTodos, "Yapılacaklar");

  const decisionRows = [["#", "Karar"]];
  (desicions || []).forEach((decision, i) => {
    decisionRows.push([i + 1, safe(decision)]);
  });
  if (decisionRows.length === 1) decisionRows.push(["", ""]);
  const wsDecisions = XLSX.utils.aoa_to_sheet(decisionRows);
  wsDecisions["!cols"] = [{ wch: 6 }, { wch: 70 }];
  XLSX.utils.book_append_sheet(wb, wsDecisions, "Kararlar");

  const participantRows = [
    ["Taraf", "Pozisyon", "İsim", "E-Posta", "Telefon"],
  ];
  (participants || []).forEach((p) => {
    participantRows.push([
      safe(p?.side),
      safe(p?.position),
      safe(p?.displayName),
      safe(p?.email),
      safe(p?.phoneNumber),
    ]);
  });
  if (participantRows.length === 1) {
    participantRows.push(["", "", "", "", ""]);
  }
  const wsParticipants = XLSX.utils.aoa_to_sheet(participantRows);
  wsParticipants["!cols"] = [
    { wch: 12 },
    { wch: 18 },
    { wch: 24 },
    { wch: 32 },
    { wch: 18 },
  ];
  XLSX.utils.book_append_sheet(wb, wsParticipants, "Katılımcılar");

  const cleanName = String(fileName || "toplanti-tutanagi")
    .replace(/[\\/:*?"<>|]+/g, "-")
    .trim()
    .slice(0, 80);
  XLSX.writeFile(wb, `${cleanName || "toplanti-tutanagi"}.xlsx`);
}
